"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.binary = void 0;
const chars_1 = require("./chars");
const encode = (value) => chars_1.chars(value)
    .map((character) => character.charCodeAt(0).toString(2))
    .join(" ");
const decode = (value) => value
    .split(" ")
    .map((character) => String.fromCharCode(parseInt(character, 2)))
    .join("");
exports.binary = { encode, decode };
//# sourceMappingURL=binary.js.map